import { render } from "./App.vue?vue&type=template&id=cdb07672"
const script = {}

import "./App.vue?vue&type=style&index=0&id=cdb07672&lang=scss"

import exportComponent from "/Users/vivianerbenich/Desktop/git/greeting-card-automation/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__